// src/pages/ResetPassword.js
import { useState } from "react";
import Api from "../../../../shared/api/api";
import "../styles/Auth.css";

export default function ResetPassword() {
  const [step, setStep] = useState(1);
  const [username, setUsername] = useState("");
  const [question, setQuestion] = useState("");
  const [formData, setFormData] = useState({
    securityAnswer: "",
    birthDate: "",
    newPassword: "",
    confirmPassword: ""
  });
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  async function handleUsernameSubmit(e) {
    e.preventDefault();
    try {
      const res = await Api.getByTitleOrUsername("users", username);
      setQuestion(res.securityQuestion);
      setStep(2);
    } catch (err) {
      setError("User not found.");
    }
  }

  async function handleResetSubmit(e) {
    e.preventDefault();
    if (formData.newPassword !== formData.confirmPassword) {
      return setError("Passwords do not match.");
    }

    try {
      await Api.request("auth/reset-password", {
        username,
        securityAnswer: formData.securityAnswer,
        birthDate: formData.birthDate,
        newPassword: formData.newPassword
      }, "post");

      setMessage("Password successfully reset. You can now log in.");
      setError(null);
      setStep(3);
    } catch (err) {
      setError("Reset failed. Check your answers and birth date.");
    }
  }

  function handleChange(evt) {
    const { name, value } = evt.target;
    setFormData(f => ({ ...f, [name]: value }));
  }

  return (
    <div className="auth-container">
      <h2>Reset Password</h2>

      {step === 1 && (
        <form onSubmit={handleUsernameSubmit} className="auth-form">
          <input
            type="text"
            placeholder="Enter your username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <button type="submit">Next</button>
        </form>
      )}

      {step === 2 && (
        <form onSubmit={handleResetSubmit} className="auth-form">
          <p className="auth-question">Security Question: {question}</p>
          <input
            type="text"
            name="securityAnswer"
            placeholder="Your Answer"
            value={formData.securityAnswer}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="birthDate"
            placeholder="Your Birth Date (exact format used to register)"
            value={formData.birthDate}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="newPassword"
            placeholder="New Password"
            value={formData.newPassword}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirm Password"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />
          <button type="submit">Reset Password</button>
        </form>
      )}

      {step === 3 && message && <p className="auth-success">{message}</p>}
      {error && <p className="auth-error">{error}</p>}
    </div>
  );
}
